import { Box, Button, Collapse, Flex, Text } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { ReactComponent as ChevronDownIcon } from 'assets/icons/chevron_down.svg';
import { ReactComponent as ChevronUpIcon } from 'assets/icons/chevron_up.svg';
import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ColorPaletteList } from '../ColorPalette';
import { PUBLIC_COLOR_PALETTES } from './ExploreTab.config';

interface ExploreTabProps {
  handleShuffleColors: (colors: string[]) => void;
}

// for smaller screens with scroll - the collapse hides the overflow: https://github.com/chakra-ui/chakra-ui/issues/2966
const CollapseTransition = styled(Collapse)`
  overflow: ${({ in: isEnabled }) => (isEnabled ? 'initial !important' : 'hidden')};
`;

const sxStyle = { '& path': { stroke: 'var(--vg-colors-upgrade-blue-500)' } };

const DEFAULT_VISIBLE_COLOR_PALETTES = 6;

export const ExploreTab = ({ handleShuffleColors }: ExploreTabProps): ReactElement => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useTranslation('editor_widget_menu', { useSuspense: false, keyPrefix: 'sideMenu.brandKit' });

  const onToggleExpand = () => setIsExpanded((isExpanded) => !isExpanded);

  return (
    <>
      <Flex justifyContent='space-between' mr={4} mb={3} align='center'>
        <Text fontSize='sm' fontWeight='semibold' py={1} px={4}>
          {t('explorePalettes')}
        </Text>
        <Button
          onClick={onToggleExpand}
          rightIcon={isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
          variant='ghost'
          fontSize='sm'
          fontWeight='medium'
          color='upgrade.blue.500'
          size='sm'
          sx={sxStyle}
          _focus={{ backgroundColor: 'upgrade.blue.50' }}
          _hover={{ backgroundColor: 'upgrade.blue.50' }}
        >
          {isExpanded ? t('viewLess') : t('viewAll')}
        </Button>
      </Flex>
      <Box w='full' px={4}>
        <ColorPaletteList
          colorPaletteList={PUBLIC_COLOR_PALETTES.slice(0, DEFAULT_VISIBLE_COLOR_PALETTES)}
          hasBrandKitPermission
          onShuffle={handleShuffleColors}
        />
        <CollapseTransition in={isExpanded} animateOpacity>
          <ColorPaletteList
            colorPaletteList={PUBLIC_COLOR_PALETTES.slice(DEFAULT_VISIBLE_COLOR_PALETTES, PUBLIC_COLOR_PALETTES.length)}
            hasBrandKitPermission
            onShuffle={handleShuffleColors}
          />
        </CollapseTransition>
      </Box>
    </>
  );
};
